/**
 * Cart Bundle Configuration
 * Set + Forget bundle configuration in cart: grouped bouquets, date pickers (no Sundays), save via remove+add.
 */
(function () {
  if (window.__cartBundleConfigInit) return;
  window.__cartBundleConfigInit = true;
  const hasConfig = document.querySelector('.cart-bundle-config, .cart-item-gifting');
  const hasDrawer = document.querySelector('#CartDrawer-Form');
  if (!hasConfig && !hasDrawer) return;

  let _deliveryCfg = null;
  function getDeliveryCfg() {
    if (_deliveryCfg) return _deliveryCfg;
    try {
      const el = document.getElementById('GiftingOptionsData');
      _deliveryCfg = (el ? JSON.parse(el.textContent) : {}).delivery || {};
    } catch (e) { _deliveryCfg = {}; }
    return _deliveryCfg;
  }

  function isSundayException(date) {
    const cfg = getDeliveryCfg();
    if (!cfg.sunday_exception_enabled || !cfg.sunday_exception_date) return false;
    const ex = new Date(cfg.sunday_exception_date + 'T00:00:00');
    return date.getFullYear() === ex.getFullYear() &&
           date.getMonth() === ex.getMonth() &&
           date.getDate() === ex.getDate();
  }

  function disableSundays(date) {
    return date.getDay() === 0 && !isSundayException(date);
  }

  // Hide "unavailable on Sundays" hints when a Sunday exception is active
  if (getDeliveryCfg().sunday_exception_enabled) {
    document.querySelectorAll('.cart-sunday-hint').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  function getSydneyTime() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
  }

  function getMinDeliveryDate() {
    const now = getSydneyTime();
    const configScript = document.getElementById('GiftingOptionsData');
    let cutoffHour = 19;
    let cutoffMinute = 0;

    if (configScript) {
      try {
        const config = JSON.parse(configScript.textContent);
        if (config.delivery) {
          cutoffHour = config.delivery.cutoff_hour !== undefined ? config.delivery.cutoff_hour : 19;
          cutoffMinute = config.delivery.cutoff_minute !== undefined ? config.delivery.cutoff_minute : 0;
        }
      } catch (e) { }
    }

    const cutoff = getSydneyTime();
    cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

    const minDate = getSydneyTime();
    if (now >= cutoff) {
      minDate.setDate(minDate.getDate() + 2);
    } else {
      minDate.setDate(minDate.getDate() + 1);
    }
    return minDate;
  }

  function initConfig(container) {
    const isBundle = container.classList.contains('cart-bundle-config');
    const isSingle = container.classList.contains('cart-item-gifting');

    // Common logic: Populate occasions and messages from global GiftingOptionsData (header group)
    const configScript = document.getElementById('GiftingOptionsData');
    if (configScript) {
      try {
        const config = JSON.parse(configScript.textContent);

        // 1. Populate Occasions
        if (config.occasions && config.occasions.length > 0) {
          container.querySelectorAll('[data-bundle-config-target="occasions"]').forEach(function (selectEl) {
            const selectedVal = selectEl.dataset.initialValue || selectEl.value;
            const defaultOpt = selectEl.options[0];
            selectEl.innerHTML = '';
            if (defaultOpt) selectEl.appendChild(defaultOpt);
            config.occasions.forEach(function (occ) {
              const opt = document.createElement('option');
              opt.value = occ.value;
              opt.textContent = occ.label;
              if (occ.value === selectedVal) opt.selected = true;
              selectEl.appendChild(opt);
            });
          });
        }

        // 2. Populate Card Messages
        if (config.messages && config.messages.length > 0) {
          container.querySelectorAll('[data-bundle-config-target="messages"]').forEach(function (selectEl) {
            const defaultOpt = selectEl.querySelector('[data-config-default-target]') || selectEl.options[0];
            selectEl.innerHTML = '';
            if (defaultOpt) selectEl.appendChild(defaultOpt);

            // Group by category
            const categories = [...new Set(config.messages.map(m => m.category || 'General'))];
            categories.forEach(cat => {
              const group = document.createElement('optgroup');
              group.label = cat;
              const msgs = config.messages.filter(m => (m.category || 'General') === cat);
              msgs.forEach(msg => {
                const opt = document.createElement('option');
                opt.value = msg.message;
                opt.textContent = msg.label;
                group.appendChild(opt);
              });
              selectEl.appendChild(group);
            });
          });
        }

        // 3. Update Labels and Placeholders
        if (config.settings) {
          const labelEl = container.querySelector('[data-config-label-target]');
          if (labelEl && config.settings.card_message_label) labelEl.textContent = config.settings.card_message_label;

          const defaultMsgOpt = container.querySelector('[data-config-default-target]');
          if (defaultMsgOpt && config.settings.message_template_default) defaultMsgOpt.textContent = config.settings.message_template_default;

          const placeholderEl = container.querySelector('[data-config-placeholder-target]');
          if (placeholderEl && config.settings.card_message_placeholder) placeholderEl.placeholder = config.settings.card_message_placeholder;
        }

      } catch (e) {
        console.error('Error parsing GiftingOptionsData for cart:', e);
      }
    }

    if (isBundle) {
      const toggle = container.querySelector('[data-bundle-toggle]');
      const content = container.querySelector('.cart-bundle-config__content');
      const samePerson = container.querySelector('[data-same-person]');
      const saveBtn = container.querySelector('[data-save-bundle]');
      const cards = container.querySelectorAll('.cart-bundle-card');

      if (toggle && content) {
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !expanded);
          content.hidden = expanded;
        });
      }

      const randomDatesToggle = container.querySelector('[data-random-dates]');
      const randomFrequencyWrapper = container.querySelector('[id^="RandomFrequencyWrapper-cart-"]');
      const randomFrequencySelect = container.querySelector('[data-random-frequency]');

      function updateVisibility() {
        const same = samePerson && samePerson.checked;
        const sharedSection = container.querySelector('[data-shared-section]');

        if (sharedSection) sharedSection.style.display = same ? 'block' : 'none';

        cards.forEach((card, idx) => {
          const individualOnlyFields = card.querySelectorAll('[data-individual-only]');
          individualOnlyFields.forEach(el => el.style.display = same ? 'none' : '');

          // Re-handle address specific display if individual mode
          if (!same) {
            const deliveryContainer = card.querySelector('.delivery-address-fields');
            if (deliveryContainer) deliveryContainer.style.display = 'block';
            const sameAsPrev = card.querySelector('[data-same-as-prev]');
            if (sameAsPrev && idx > 0) sameAsPrev.parentElement.style.display = 'block';
          }
        });

        // Random dates visibility
        if (randomDatesToggle) {
          const isRandom = randomDatesToggle.checked;
          if (randomFrequencyWrapper) randomFrequencyWrapper.style.display = isRandom ? 'block' : 'none';

          // Disable individual date inputs if random is checked
          container.querySelectorAll('.cart-bundle-date-input').forEach(inp => {
            inp.disabled = isRandom;
            inp.parentElement.style.opacity = isRandom ? '0.5' : '1';
          });
        }
      }

      if (samePerson) {
        samePerson.addEventListener('change', updateVisibility);
      }
      if (randomDatesToggle) {
        randomDatesToggle.addEventListener('change', updateVisibility);
      }
      updateVisibility();

      function generateRandomDates() {
        if (!randomDatesToggle || !randomDatesToggle.checked) return null;

        const frequency = randomFrequencySelect ? randomFrequencySelect.value : 'Weekly';
        const interval = frequency === 'Weekly' ? 7 : (frequency === 'Fortnightly' ? 14 : 28);
        const dates = [];
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1); // Start tomorrow

        for (let i = 0; i < cards.length; i++) {
          // Skip Sundays (unless it's an exception like Mother's Day)
          if (currentDate.getDay() === 0 && !isSundayException(currentDate)) {
            currentDate.setDate(currentDate.getDate() + 1);
          }
          dates.push(currentDate.toISOString().split('T')[0]);
          currentDate.setDate(currentDate.getDate() + interval);
        }
        return dates.join(', ');
      }

      cards.forEach((card, idx) => {


        const dateInput = card.querySelector('.cart-bundle-date-input');
        if (dateInput && typeof flatpickr !== 'undefined') {
          flatpickr(dateInput, {
            dateFormat: 'Y-m-d',
            minDate: getMinDeliveryDate(),
            disable: [disableSundays]
          });
        }

        const messageInput = card.querySelector('textarea[data-prop^="Message "]');
        if (messageInput) {
          const countEl = card.querySelector('[data-char-count]');
          const updateCount = () => {
            if (countEl) countEl.textContent = messageInput.value.length + ' / 250';
          };
          messageInput.addEventListener('input', updateCount);
          updateCount();

          const templateSelect = card.querySelector('[id^="MessageTemplate-"]');
          if (templateSelect) {
            templateSelect.addEventListener('change', function () {
              if (this.value) {
                messageInput.value = this.value;
                messageInput.dispatchEvent(new Event('input'));
              }
            });
          }
        }

        const countrySelect = card.querySelector('select[data-default-country]');
        if (countrySelect && countrySelect.dataset.defaultCountry) {
          countrySelect.value = countrySelect.dataset.defaultCountry;
        }
      });

      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          const lineIndex = parseInt(container.dataset.lineIndex, 10);
          const variantId = container.dataset.variantId;
          const quantity = parseInt(container.dataset.quantity, 10) || 1;
          const sellingPlanId = container.dataset.sellingPlanId || '';
          const same = samePerson && samePerson.checked;

          const props = {};

          if (randomDatesToggle && randomDatesToggle.checked) {
            props['Random_Dates'] = 'true';
            props['Random_Frequency'] = randomFrequencySelect ? randomFrequencySelect.value : 'Weekly';
            props['_Selected_Dates'] = generateRandomDates();
          } else {
            const dateInputs = container.querySelectorAll('.cart-bundle-date-input');
            const dates = [];
            dateInputs.forEach((inp, idx) => {
              if (inp.value) {
                dates.push(inp.value);
                // Save individual date property for checkout display
                props[`Bouquet ${idx + 1}: Delivery Date`] = inp.value;
              }
            });
            if (dates.length) props['_Selected_Dates'] = dates.join(', ');
            props['Random_Dates'] = 'false';
          }

          if (same) {
            // Collect shared props
            const sharedSection = container.querySelector('[data-shared-section]');
            const sharedDetailMap = {
              'Recipient Name': 'Bouquet {i}: Recipient Name',
              'Who From': 'Bouquet {i}: From',
              'Recipient Phone': 'Bouquet {i}: Recipient Phone',
              'Address1': 'Bouquet {i}: Delivery Address Line 1',
              'Address2': 'Bouquet {i}: Delivery Address Line 2',
              'City': 'Bouquet {i}: Delivery City',
              'Country': 'Bouquet {i}: Delivery Country',
              'Province': 'Bouquet {i}: Delivery State/Province',
              'Zip': 'Bouquet {i}: Delivery ZIP/Postal Code'
            };

            sharedSection.querySelectorAll('[data-shared-prop]').forEach(el => {
              const sharedPropKey = el.dataset.sharedProp;
              const propPattern = sharedDetailMap[sharedPropKey];
              const val = el.value ? String(el.value).trim() : '';
              if (!propPattern || !val) return;

              for (let i = 1; i <= cards.length; i++) {
                const actualProp = propPattern.replace('{i}', i);
                props[actualProp] = val;
              }
            });

            // Individual card unique props (Message and Occasion)
            cards.forEach((card, idx) => {
              const i = idx + 1;
              // Separator for Checkout/Order sorting - 3 lines for visual spacing
              // Using zero-width spaces to differentiate keys but look identical
              props[`Bouquet ${i}`] = '------------------';
              props[`Bouquet ${i}​`] = '------------------'; // contains zero-width space
              props[`Bouquet ${i}​​`] = '------------------'; // contains two zero-width spaces

              const msgEl = card.querySelector(`[data-prop="Message ${i}"]`);
              if (msgEl && msgEl.value) props[`Bouquet ${i}: Card Message`] = msgEl.value.trim();

              const occasionEl = card.querySelector(`[data-prop="Occasion ${i}"]`);
              if (occasionEl && occasionEl.value) props[`Bouquet ${i}: Occasion`] = occasionEl.value.trim();
            });
          } else {
            // Add Separators for individual mode too
            for (let i = 1; i <= cards.length; i++) {
              props[`Bouquet ${i}`] = '------------------';
              props[`Bouquet ${i}​`] = '------------------';
              props[`Bouquet ${i}​​`] = '------------------';
            }

            container.querySelectorAll('[data-prop]').forEach(el => {
              if (el.dataset.prop === 'Selected_Dates') return;
              let prop = el.dataset.prop;
              const val = el.value ? String(el.value).trim() : '';

              // Remap individual props to grouped naming convention
              if (prop.startsWith('Recipient ')) prop = prop.replace(/Recipient (\d+)/, 'Bouquet $1: Recipient Name');
              else if (prop.startsWith('Who From ')) prop = prop.replace(/Who From (\d+)/, 'Bouquet $1: From');
              else if (prop.startsWith('Recipient Phone ')) prop = prop.replace(/Recipient Phone (\d+)/, 'Bouquet $1: Recipient Phone');
              else if (prop.startsWith('Occasion ')) prop = prop.replace(/Occasion (\d+)/, 'Bouquet $1: Occasion');
              else if (prop.startsWith('Message ')) prop = prop.replace(/Message (\d+)/, 'Bouquet $1: Card Message');
              else if (prop.includes(' - Delivery ')) prop = prop.replace(' - Delivery ', ': Delivery ');

              if (prop && val) props[prop] = val;
            });
          }


          // Gift Field Validation
          const validationErrors = [];

          // Validate delivery dates (unless random dates is checked)
          if (!randomDatesToggle || !randomDatesToggle.checked) {
            const dateInputs = container.querySelectorAll('.cart-bundle-date-input');
            dateInputs.forEach((inp, idx) => {
              if (!inp.value || !inp.value.trim()) {
                validationErrors.push(`Bouquet ${idx + 1}: Delivery Date is required.`);
              }
            });
          }

          // Validate recipient names and card messages
          if (same) {
            // In shared mode, validate shared recipient name
            const sharedRecipient = container.querySelector('[data-shared-prop="Recipient Name"]');
            if (!sharedRecipient || !sharedRecipient.value || !sharedRecipient.value.trim()) {
              validationErrors.push('Shared Recipient Name is required.');
            }

            // Validate each bouquet's card message
            cards.forEach((card, idx) => {
              const i = idx + 1;
              const msgEl = card.querySelector(`[data-prop="Message ${i}"]`);
              if (!msgEl || !msgEl.value || !msgEl.value.trim()) {
                validationErrors.push(`Bouquet ${i}: Card Message is required.`);
              }
            });
          } else {
            // In individual mode, validate each bouquet's recipient name and card message
            cards.forEach((card, idx) => {
              const i = idx + 1;
              const recipientEl = card.querySelector(`[data-prop="Recipient ${i}"]`);
              const msgEl = card.querySelector(`[data-prop="Message ${i}"]`);

              if (!recipientEl || !recipientEl.value || !recipientEl.value.trim()) {
                validationErrors.push(`Bouquet ${i}: Recipient Name is required.`);
              }
              if (!msgEl || !msgEl.value || !msgEl.value.trim()) {
                validationErrors.push(`Bouquet ${i}: Card Message is required.`);
              }
            });
          }

          // Show validation errors if any
          if (validationErrors.length > 0) {
            alert('Please complete the following required fields:\n\n• ' + validationErrors.join('\n• '));
            saveBtn.disabled = false;
            saveBtn.textContent = 'Save bouquet details';
            return; // Stop save
          }


          // Postcode Validation
          const configScript = document.getElementById('GiftingOptionsData');
          if (configScript) {
            try {
              const config = JSON.parse(configScript.textContent);
              if (config.delivery && config.delivery.allowed_postcodes) {
                const allowedStr = config.delivery.allowed_postcodes;
                if (allowedStr && allowedStr.trim().length > 0) {
                  const allowed = allowedStr.split(',').map(s => s.trim());
                  const errors = [];

                  // Helper to validate a specific postcode value
                  const validate = (postcode, label) => {
                    if (postcode && !allowed.includes(postcode)) {
                      errors.push(`${label}: Postcode ${postcode} is not available for delivery.`);
                    }
                  };

                  if (same) {
                    // In shared mode, we look for the single shared zip input
                    const sharedZipEl = container.querySelector('[data-shared-prop="Zip"]');
                    if (sharedZipEl && sharedZipEl.value) {
                      validate(sharedZipEl.value.trim(), 'Shared Address');
                    }
                  } else {
                    // In individual mode, we check each bouquet's zip input
                    // Note: We need to reconstruct the property name used in the DOM for individual cards
                    // The inputs have data-prop="Bouquet {{ i }} - Delivery ZIP/Postal Code"
                    for (let i = 1; i <= cards.length; i++) {
                      const propName = `Bouquet ${i} - Delivery ZIP/Postal Code`;
                      const zipEl = container.querySelector(`[data-prop="${propName}"]`);
                      if (zipEl && zipEl.value) {
                        validate(zipEl.value.trim(), `Bouquet ${i}`);
                      }
                    }
                  }

                  if (errors.length > 0) {
                    alert('Delivery unavailable for the following addresses:\n- ' + errors.join('\n- '));
                    saveBtn.disabled = false;
                    saveBtn.textContent = 'Save bouquet details';
                    return; // Stop save
                  }
                }
              }
            } catch (e) {
              console.error('Validation error:', e);
            }
          }

          saveChanges(saveBtn, lineIndex, variantId, quantity, sellingPlanId, props);
        });
      }
    }

if (isSingle) {
      const giftFields = container.querySelector('[data-gift-fields]');
      const giftToggles = container.querySelectorAll('[data-gift-toggle]');
      const saveBtn = container.querySelector('[data-save-gifting]');
      const dateInput = container.querySelector('.cart-item-date-input');
      const messageInput = container.querySelector('textarea[data-prop="Card Message"]');

      function updateGiftFieldsVisibility() {
        const checked = container.querySelector('[data-gift-toggle]:checked');
        const isGiftYes = checked ? checked.value === 'true' : true;
        if (giftFields) giftFields.hidden = !isGiftYes;
      }

      giftToggles.forEach(function (toggle) {
        toggle.addEventListener('change', function () {
          updateGiftFieldsVisibility();
          updateCheckoutAvailability();
        });
      });
      updateGiftFieldsVisibility();

      if (dateInput && typeof flatpickr !== 'undefined') {
        flatpickr(dateInput, {
          dateFormat: 'Y-m-d',
          altInput: true,
          altFormat: 'd/m/Y',
          minDate: getMinDeliveryDate(),
          disable: [disableSundays]
        });
      }

      const templateSelect = container.querySelector('[id^="MessageTemplate-"]');
      if (templateSelect && messageInput) {
        templateSelect.addEventListener('change', function () {
          if (this.value) {
            messageInput.value = this.value;
            messageInput.dispatchEvent(new Event('input'));
          }
        });
      }

      if (messageInput) {
        const countEl = container.querySelector('[data-char-count]');
        const updateCount = () => {
          if (countEl) countEl.textContent = messageInput.value.length + ' / 250';
        };
        messageInput.addEventListener('input', updateCount);
        updateCount();
      }

      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          const lineIndex = parseInt(container.dataset.lineIndex, 10);
          const variantId = container.dataset.variantId;
          const quantity = parseInt(container.dataset.quantity, 10) || 1;
          const sellingPlanId = container.dataset.sellingPlanId || '';

          const checkedToggle = container.querySelector('[data-gift-toggle]:checked');
          const isGiftYes = checkedToggle ? checkedToggle.value === 'true' : true;

          const props = {
            'is_gift': isGiftYes ? 'true' : 'false'
          };

          const skipDate = container.dataset.skipDate === 'true';
          const deliveryDate = container.querySelector('[data-prop="Requested_Delivery_Date"]');

          if (!skipDate) {
            if (!deliveryDate || !deliveryDate.value || !deliveryDate.value.trim()) {
              alert('Please select a delivery date.');
              saveBtn.disabled = false;
              saveBtn.textContent = 'Lock It In';
              return;
            }
            props['Requested_Delivery_Date'] = deliveryDate.value.trim();
          }

          const addressFields = container.querySelectorAll('[data-address-prop]');
          const missingAddress = [];
          addressFields.forEach(el => {
            const prop = el.dataset.addressProp;
            const val = el.value ? String(el.value).trim() : '';
            if (val) {
              props[prop] = val;
            } else if (el.dataset.required === 'true') {
              missingAddress.push(prop);
            }
          });
          if (missingAddress.length > 0) {
            alert('Please complete the delivery address (' + missingAddress.join(', ') + ').');
            saveBtn.disabled = false;
            saveBtn.textContent = 'Lock It In';
            return;
          }

          if (isGiftYes) {
            container.querySelectorAll('[data-prop]').forEach(el => {
              const prop = el.dataset.prop;
              const val = el.value ? String(el.value).trim() : '';
              if (prop && val) props[prop] = val;
            });
          }

          saveChanges(saveBtn, lineIndex, variantId, quantity, sellingPlanId, props);
        });
      }
    }
  }

  function saveChanges(btn, lineIndex, variantId, quantity, sellingPlanId, props) {
    btn.disabled = true;
    btn.textContent = 'Saving...';

    const routes = window.routes || { cart_change_url: '/cart/change.js', cart_add_url: '/cart/add.js' };

    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
      .then(() => {
        const addBody = {
          id: variantId,
          quantity: quantity,
          properties: props
        };
        if (sellingPlanId) addBody.selling_plan = parseInt(sellingPlanId, 10);
        return fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(addBody)
        });
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Failed to save');
        }
        // window.location.href = '/checkout';
        // Reload to stay on cart page so user can fill out other items if needed
        window.location.reload();
      })
      .catch(err => {
        btn.disabled = false;
        btn.textContent = btn.hasAttribute('data-save-bundle') ? 'Save bouquet details' : 'Lock It In';
        alert(err.message || 'Could not save. Please try again.');
      });
  }

  function runInit() {
    document.querySelectorAll('.cart-bundle-config, .cart-item-gifting').forEach(function (el) {
      try {
        initConfig(el);
      } catch (e) {
        console.error('Cart config init error:', e);
      }
    });
    initCheckoutGuard();
    initDrawerGuard();
    bindValidationListeners();
    updateCheckoutAvailability(false);
  }

  function initCheckoutGuard() {
    const form = document.querySelector('form#cart');
    if (!form || form.dataset.deliveryDateGuard === 'true') return;
    form.dataset.deliveryDateGuard = 'true';

    form.addEventListener('submit', (e) => {
      const submitter = e.submitter || document.activeElement;
      const isCheckout =
        submitter &&
        (submitter.getAttribute('name') === 'checkout' ||
          submitter.classList.contains('cart__checkout-button'));

      if (!isCheckout) return;

      const validation = validateDeliveryDates();
      if (!validation.valid) {
        e.preventDefault();
        showCartError(validation.message, validation.firstMissingInput);
      }
    });
  }

  function showDeliveryFeeReminder(submitter) {
    if (document.getElementById('DeliveryFeeReminder')) return;

    const overlay = document.createElement('div');
    overlay.id = 'DeliveryFeeReminder';
    overlay.className = 'delivery-fee-reminder-overlay';
    overlay.innerHTML =
      '<div class="delivery-fee-reminder-box">' +
        '<p class="delivery-fee-reminder-text">Did you remember to add your delivery fee?</p>' +
        '<div class="delivery-fee-reminder-actions">' +
          '<button type="button" class="delivery-fee-reminder-back">Go back</button>' +
          '<button type="button" class="delivery-fee-reminder-continue">Continue to checkout</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    const close = () => overlay.remove();

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.delivery-fee-reminder-back').addEventListener('click', close);
    overlay.querySelector('.delivery-fee-reminder-continue').addEventListener('click', () => {
      window.__deliveryFeeReminderConfirmed = true;
      close();
      submitter.click();
    });
  }

  function initDrawerGuard() {
    const form = document.querySelector('#CartDrawer-Form');
    if (!form || form.dataset.deliveryDateGuard === 'true') return;
    form.dataset.deliveryDateGuard = 'true';

    form.addEventListener('submit', (e) => {
      const submitter = e.submitter || document.activeElement;
      const isCheckout =
        submitter &&
        (submitter.getAttribute('name') === 'checkout' ||
          submitter.id === 'CartDrawer-Checkout');

      if (!isCheckout) return;

      const validation = validateDeliveryDates();
      if (!validation.valid) {
        e.preventDefault();
        showDrawerError(validation.message);
      }
    });
  }

  function bindValidationListeners() {
    const handler = () => updateCheckoutAvailability();
    document.addEventListener('input', (event) => {
      if (event.target.matches('.cart-item-date-input, .cart-bundle-date-input')) {
        clearFieldError(event.target);
        handler();
      }
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('.cart-item-date-input, .cart-bundle-date-input, [data-random-dates]')) {
        clearFieldError(event.target);
        handler();
      }
    });
    document.addEventListener('cart:change', handler);
  }

  function validateDeliveryDates() {
    const inputValidation = validateDeliveryDatesFromInputs();
    if (!inputValidation.valid) return inputValidation;

    const unsavedValidation = validateUnsavedChanges();
    if (!unsavedValidation.valid) return unsavedValidation;

    const dataValidation = validateDeliveryDatesFromData();
    if (!dataValidation.valid) return dataValidation;

    const dateEffectivityValidation = validateDateEffectivity();
    if (!dateEffectivityValidation.valid) return dateEffectivityValidation;

    return { valid: true };
  }

  function validateDateEffectivity() {
    const minAllowed = getMinDeliveryDate();
    const minDateStr = minAllowed.toISOString().split('T')[0];
    let invalidDateInput = null;

    // Check single items
    document.querySelectorAll('.cart-item-gifting').forEach((container) => {
      const input = container.querySelector('.cart-item-date-input');
      if (input && input.value) {
        const selected = input.value; // Expected YYYY-MM-DD
        if (selected < minDateStr) {
          invalidDateInput = input;
        }
      }
    });

    // Check bundle items
    document.querySelectorAll('.cart-bundle-config').forEach((container) => {
      const randomToggle = container.querySelector('[data-random-dates]');
      if (randomToggle && randomToggle.checked) return;

      container.querySelectorAll('.cart-bundle-date-input').forEach((input) => {
        if (input && input.value) {
          const selected = input.value;
          if (selected < minDateStr) {
            invalidDateInput = input;
          }
        }
      });
    });

    if (invalidDateInput) {
      setFieldError(invalidDateInput);
      return {
        valid: false,
        firstMissingInput: invalidDateInput,
        message: 'One or more selected delivery dates are no longer available (past the 7pm cutoff). Please select a new date.'
      };
    }
    return { valid: true };
  }

  function validateDeliveryDatesFromInputs() {
    let firstMissingInput = null;
    const missingInputs = [];

    // Single items: require delivery date, recipient name, and card message
document.querySelectorAll('.cart-item-gifting').forEach((container) => {
      const dateInput = container.querySelector('.cart-item-date-input');

      if (dateInput && (!dateInput.value || !dateInput.value.trim())) {
        if (!firstMissingInput) firstMissingInput = dateInput;
        missingInputs.push(dateInput);
      }
    });

    // Bundle items: require dates, recipients, and messages unless random dates is checked
    document.querySelectorAll('.cart-bundle-config').forEach((container) => {
      const randomDatesToggle = container.querySelector('[data-random-dates]');
      const isRandom = randomDatesToggle && randomDatesToggle.checked;
      if (isRandom) return;

      const sharedToggle = container.querySelector('[id^="BulkSyncRecipient-"]');
      const isShared = sharedToggle && sharedToggle.checked;

      if (isShared) {
        // Check shared fields
        const sharedName = container.querySelector('[data-shared-prop="Recipient Name"]');
        if (sharedName && (!sharedName.value || !sharedName.value.trim())) {
          if (!firstMissingInput) firstMissingInput = sharedName;
          missingInputs.push(sharedName);
        }
      }

      // Check per-bouquet fields
      container.querySelectorAll('.cart-bundle-card').forEach((card, idx) => {
        const dateInput = card.querySelector('.cart-bundle-date-input');
        if (dateInput && (!dateInput.value || !dateInput.value.trim())) {
          if (!firstMissingInput) firstMissingInput = dateInput;
          missingInputs.push(dateInput);
        }

        if (!isShared) {
          const nameInput = card.querySelector('[data-prop^="Recipient "]');
          if (nameInput && (!nameInput.value || !nameInput.value.trim())) {
            if (!firstMissingInput) firstMissingInput = nameInput;
            missingInputs.push(nameInput);
          }
        }

        const messageInput = card.querySelector('[data-prop^="Message "]');
        if (messageInput && (!messageInput.value || !messageInput.value.trim())) {
          if (!firstMissingInput) firstMissingInput = messageInput;
          missingInputs.push(messageInput);
        }
      });
    });

    if (firstMissingInput) {
      missingInputs.forEach(setFieldError);
      return {
        valid: false,
        firstMissingInput,
        message: 'Please complete all required gifting and delivery details before proceeding to checkout.'
      };
    }

    return { valid: true };
  }

  function validateUnsavedChanges() {
    let hasUnsaved = false;

    document.querySelectorAll('.cart-item-gifting').forEach((container) => {
      const input = container.querySelector('.cart-item-date-input');
      if (!input) return;
      const initial = (input.dataset.initialValue || '').trim();
      const current = (input.value || '').trim();
      if (initial !== current) hasUnsaved = true;
    });

    document.querySelectorAll('.cart-bundle-config').forEach((container) => {
      const randomToggle = container.querySelector('[data-random-dates]');
      const initialRandom = (container.dataset.initialRandom || 'false') === 'true';
      const currentRandom = randomToggle ? randomToggle.checked : false;
      if (initialRandom !== currentRandom) hasUnsaved = true;

      if (!currentRandom) {
        container.querySelectorAll('.cart-bundle-date-input').forEach((input) => {
          const initial = (input.dataset.initialValue || '').trim();
          const current = (input.value || '').trim();
          if (initial !== current) hasUnsaved = true;
        });
      }
    });

    if (hasUnsaved) {
      return {
        valid: false,
        firstMissingInput: null,
        message: 'Please save delivery details before proceeding to checkout.'
      };
    }

    return { valid: true };
  }

  function validateDeliveryDatesFromData() {
    const missingItem = document.querySelector('[data-delivery-required="true"][data-delivery-complete="false"]');
    if (missingItem) {
      return {
        valid: false,
        firstMissingInput: null,
        message: 'Delivery dates are required for each bouquet. Please add dates and save before checkout.'
      };
    }

    return { valid: true };
  }

  function updateCheckoutAvailability(showMessage) {
    if (showMessage === undefined) showMessage = true;
    const validation = validateDeliveryDates();
    const shouldBlock = !validation.valid;

    const cartCheckoutButton = document.querySelector('.cart__checkout-button');
    if (cartCheckoutButton && !cartCheckoutButton.closest('cart-drawer')) {
      if (shouldBlock) {
        cartCheckoutButton.setAttribute('aria-disabled', 'true');
        cartCheckoutButton.disabled = true;
      } else {
        cartCheckoutButton.removeAttribute('aria-disabled');
        cartCheckoutButton.disabled = false;
      }
    }

    const dynamicCheckout = document.querySelector('.cart__footer-dynamic-checkout');
    if (dynamicCheckout) {
      dynamicCheckout.setAttribute('data-disabled', shouldBlock ? 'true' : 'false');
    }

    const cartHint = document.getElementById('cart-delivery-date-hint');
    if (cartHint) {
      const show = shouldBlock && showMessage;
      cartHint.hidden = !show;
      if (show) {
        cartHint.setAttribute('role', 'alert');
        if (validation.message) cartHint.textContent = validation.message;
      }
    }

    const drawerCheckoutButton = document.getElementById('CartDrawer-Checkout');
    const drawer = document.querySelector('cart-drawer');
    const drawerIsEmpty = drawer && drawer.classList.contains('is-empty');
    if (drawerCheckoutButton) {
      if (drawerIsEmpty) {
        drawerCheckoutButton.disabled = true;
        drawerCheckoutButton.setAttribute('aria-disabled', 'true');
      } else {
        drawerCheckoutButton.disabled = shouldBlock;
        drawerCheckoutButton.setAttribute('aria-disabled', shouldBlock ? 'true' : 'false');
      }
    }

    const drawerWarning = document.getElementById('CartDrawer-DateWarning');
    if (drawerWarning) {
      drawerWarning.hidden = !shouldBlock;
      if (shouldBlock) {
        drawerWarning.setAttribute('role', 'alert');
        if (validation.message) drawerWarning.textContent = validation.message;
      }
    }
  }

  function showCartError(message, focusInput) {
    const errorContainer = document.getElementById('cart-errors');
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.setAttribute('role', 'alert');
      errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      alert(message);
    }

    if (focusInput) {
      focusInput.style.borderColor = 'rgb(var(--color-error, 220, 38, 38))';
      focusInput.style.boxShadow = '0 0 0 1px rgb(var(--color-error, 220, 38, 38))';
      setTimeout(() => focusInput.focus(), 200);
      const clear = () => {
        focusInput.style.borderColor = '';
        focusInput.style.boxShadow = '';
      };
      focusInput.addEventListener('input', clear, { once: true });
      focusInput.addEventListener('change', clear, { once: true });
    }
  }

  function setFieldError(input) {
    if (!input) return;
    const wrapper = input.closest('.cart-bundle-card__field, .cart-item-gifting__field');
    if (!wrapper) return;
    const error = wrapper.querySelector('[data-field-error]');
    if (!error) return;
    error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
  }

  function clearFieldError(input) {
    if (!input) return;
    const wrapper = input.closest('.cart-bundle-card__field, .cart-item-gifting__field');
    if (!wrapper) return;
    const error = wrapper.querySelector('[data-field-error]');
    if (!error) return;
    error.hidden = true;
    input.removeAttribute('aria-invalid');
  }

  function showDrawerError(message) {
    const warning = document.getElementById('CartDrawer-DateWarning');
    if (warning) {
      warning.textContent = message;
      warning.hidden = false;
      warning.setAttribute('role', 'alert');
    } else {
      alert(message);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
})();
